import { render, staticRenderFns } from "./ColumnsList.vue?vue&type=template&id=8a06d9b2&scoped=true&"
import script from "./ColumnsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ColumnsList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ColumnsList.vue?vue&type=style&index=0&id=8a06d9b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a06d9b2",
  null
  
)

export default component.exports